function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useViewState } from "../Context";
import Icon, { StyledIcon } from "../../Styled/Icon";
import { jsx as _jsx } from "react/jsx-runtime";
export const ExternalLinkWithWarning = props => {
  const viewState = useViewState();
  const {
    t
  } = useTranslation();
  const onClick = evt => {
    evt.stopPropagation();
    evt.preventDefault();
    viewState.terria.notificationState.addNotificationToQueue({
      title: t("core.unverifiedExternalLink.title"),
      message: t("core.unverifiedExternalLink.message", {
        url: props.attributes.href
      }),
      confirmText: t("core.unverifiedExternalLink.confirmText"),
      denyText: t("core.unverifiedExternalLink.denyText"),
      confirmAction: () => {
        var _window$open;
        return (_window$open = window.open(props.attributes.href, "_blank")) === null || _window$open === void 0 ? void 0 : _window$open.focus();
      }
    });
  };
  if (!props.attributes.href) {
    return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props.attributes), {}, {
      children: props.children
    }));
  }
  return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props.attributes), {}, {
    onClick: onClick,
    children: props.children
  }));
};
export const ExternalLinkIcon = styled(StyledIcon).attrs({
  glyph: Icon.GLYPHS.externalLink,
  styledWidth: "10px",
  styledHeight: "10px",
  displayInline: true
}).withConfig({
  displayName: "ExternalLink__ExternalLinkIcon",
  componentId: "sc-p48thz-0"
})(["margin-left:5px;fill:currentColor;"]);